import 'rxjs/Rx';
import {EventEmitter, Injectable} from '@angular/core';
import {LoggerService} from './logger.service';

export class EventObject {
    type: string;
    payload: any;

    constructor(type?: string, payload?: any) {
        this.type = type;
        this.payload = payload;
    }
}

@Injectable()
export class EventService {

    private event: EventEmitter<any> = new EventEmitter<any>(true);

    constructor(private logger: LoggerService) {
    }

    emit(eventObject: EventObject) {

        this.logger.log('EventService: emit', eventObject);

        this.event.emit(eventObject);

    }

    subscribe(callback: (eventObject: EventObject) => void) {

        this.logger.log('EventService: subscribe', callback);

        return this.event.subscribe((eventObject: EventObject) => callback(eventObject));
    }

}
